import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { map } from 'rxjs/operators';

// CRM follow-up tasks, one customer, one assignee, one due date.
// Kept in its own `crm_tasks` collection — distinct from the unrelated
// `tasks` collection used by ScheculedTaskService for machine-maintenance
// scheduling (system_info/company/sites domain, no kundekortId).
@Injectable({
  providedIn: 'root'
})
export class CrmTaskService {
  constructor(private afs: AngularFirestore) { }

  private mapDocs(docs: any[]) {
    return docs.map(obj => ({
      ...obj.payload.doc.data() as object,
      dbid: obj.payload.doc.id,
    }));
  }

  addTask(task: any) {
    return this.afs.collection('crm_tasks').add({
      ...task,
      status: 'open',
      createdAt: new Date(),
    });
  }

  getTasksByKundekortId(kundekortId: string) {
    return this.afs.collection('crm_tasks', ref => ref.where('kundekortId', '==', kundekortId))
      .snapshotChanges().pipe(map(docs => this.mapDocs(docs)));
  }

  // Filtered/sorted client-side on top of a single-field query so this
  // doesn't need a composite Firestore index for (assigneeId, status).
  getOpenTasksForAssignee(assigneeId: string) {
    return this.afs.collection('crm_tasks', ref => ref.where('assigneeId', '==', assigneeId))
      .snapshotChanges().pipe(map(docs => this.mapDocs(docs).filter((t: any) => t.status === 'open')));
  }

  getOpenTasks$() {
    return this.afs.collection('crm_tasks', ref => ref.where('status', '==', 'open'))
      .snapshotChanges().pipe(map(docs => this.mapDocs(docs)));
  }

  completeTask(id: string) {
    return this.afs.collection('crm_tasks').doc(id).update({ status: 'done', completedAt: new Date() });
  }

  reopenTask(id: string) {
    return this.afs.collection('crm_tasks').doc(id).update({ status: 'open', completedAt: null });
  }

  updateTask(id: string, data: any) {
    return this.afs.collection('crm_tasks').doc(id).update(data);
  }

  deleteTask(id: string) {
    return this.afs.collection('crm_tasks').doc(id).delete();
  }
}
